// singleton module for managing the HotkeyRegistry instance

import type HotkeyRegistry from './HotkeyRegistry';

let hotkeyRegistry: HotkeyRegistry;

export const getHotkeyRegistry = (): HotkeyRegistry => {
  return hotkeyRegistry;
};

export const setHotkeyRegistry = (newHotkeyRegistry: HotkeyRegistry) => {
  hotkeyRegistry = newHotkeyRegistry;
};
